<template>
  <v-navigation-drawer
    v-model="drawerControl"
    class="panel story-sidebar"
    width="400"
    app
    right
    floating
  >
    <!-- Topo -->
    <template v-slot:prepend>
      <div class="panel-header">
        <div class="header-slot left">
          <div class="title">Conteúdo Relacionado</div>
        </div>
        <div class="header-slot right">
          <v-btn
            v-if="$vuetify.breakpoint.mdAndDown"
            icon
            @click="drawerControl = !drawerControl"
          >
            <v-icon>mdi-card-bulleted-off</v-icon>
          </v-btn>
        </div>
      </div>
    </template>

    <!-- Meio -->
    <div class="panel-content flex-column">
      <v-tabs v-model="tabs" centered grow color="graydark">
        <v-tab v-for="item in tabItems" :key="item">{{ item }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <!-- similar stories -->
          <StoriesWrapper
            @select-similar-story="selectSimilarStory"
            @load-more-stories="loadNews"
            :stories="this.similarStories"
            :isLoading="isLoadingSimilarStories"
            :drawer="drawerControl"
          />
        </v-tab-item>
        <v-tab-item>
          <!-- related videos globoplay -->
          <VideosGloboplayWrapper
            :selectedStory="selectedStory"
            :videos="this.relatedVideos.globoi"
            :isLoading="isLoadingRelatedVideos"
            :videoQuery="videoQuery"
            @setVideoQuery="setVideoQuery"
            @handleVideoQuerySearch="handleVideoQuerySearch"
            @searchVideos="searchVideos"
            @clearVideoSearch="clearVideoSearch"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-navigation-drawer>
</template>

<script>
import VideosGloboplayWrapper from '@/components/stories/storyDetailSidebar/VideosGloboplayWrapper.vue';
import StoriesWrapper from '@/components/stories/storyDetailSidebar/StoriesWrapper.vue';
import { storyModes } from '@/utils/mappers.js';
import { escapeHTML } from '@/utils/text';

export default {
  components: {
    VideosGloboplayWrapper,
    StoriesWrapper,
  },
  props: {
    storyMode: Number,
    isLoadingRelatedVideos: Boolean,
    isLoadingSimilarStories: Boolean,
    similarStories: Object,
    relatedVideos: Object,
    selectedStory: Object,
    drawer: Boolean,
  },
  data() {
    return {
      storyModes,
      tabItems: this.getAvailableTabs(),
      tabs: null,
      videoQuery: '',
    };
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('videos/resetVideos');
    next();
  },
  created() {
    this.$store.dispatch('videos/updateManualSearch', false);
  },
  watch: {
    videoQuery() {
      if (!(this.videoQuery && this.videoQuery.length === 0)) {
        this.updateManualSearch(false);
      }
    },
  },
  computed: {
    drawerControl: {
      get() {
        return this.drawer;
      },
      set(value) {
        this.toggleFilters(value);
      },
    },
  },
  methods: {
    handleBackClick() {
      this.$router.go(-1);
    },
    loadNews(story) {
      this.$emit('load-more-stories', story);
    },
    selectSimilarStory(story) {
      this.$emit('select-similar-story', story);
    },
    getAvailableTabs() {
      return ['Retrancas', 'Globoplay'];
    },
    setVideoQuery(value) {
      this.videoQuery = value;
    },
    updateManualSearch(value) {
      this.$store.dispatch('videos/updateManualSearch', value);
    },
    handleVideoQuerySearch() {
      this.$store.dispatch('videos/resetVideos');
      this.searchVideos();
    },
    clearVideoSearch() {
      this.videoQuery = '';
      this.handleVideoQuerySearch();
    },
    searchVideos() {
      if (this.videoQuery) {
        this.$store.dispatch('videos/searchRelatedVideos', {
          title: this.videoQuery,
          body: this.videoQuery,
          isManualSearch: true,
        });
      } else {
        this.$store.dispatch('videos/searchRelatedVideos', {
          title: this.selectedStory.data.title,
          body: escapeHTML(this.selectedStory.data.body),
          isManualSearch: false,
        });
      }
    },
    toggleFilters(value) {
      this.$emit('changeContentPanel', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/navigationDrawer-v2.scss';

::v-deep .v-navigation-drawer__content {
  overflow-y: hidden;
}

::v-deep .v-tab {
  flex: 1;
  font-family: 'globotipo' !important;
  font-weight: 600 !important;
  letter-spacing: 0;
  font-size: 0.88em;
  text-transform: capitalize;
  border-bottom: solid 1px $color-black-08;
}

.v-tabs-items {
  flex: 1;

  ::v-deep .container {
    padding: 0;
  }
}
</style>
